import React from "react";

const DemandSupplyGaps = ({ gaps }) => {
  const rows = gaps || [];

  if (rows.length === 0) return null;

  return (
    <section className="owner-dashboard__panel">
      <div className="owner-dashboard__panel-header">
        <div>
          <h2 className="owner-dashboard__panel-title">Demand vs. supply gaps</h2>
          <p className="owner-dashboard__panel-subtitle">
            Time blocks where families want classes but spots are scarce — or where
            you have capacity worth promoting.
          </p>
        </div>
      </div>

      <div className="owner-dashboard__table-wrap">
        <table className="owner-dashboard__table owner-dashboard__gap-table">
          <thead>
            <tr>
              <th>Status</th>
              <th>Program</th>
              <th>Day & time</th>
              <th>Classes</th>
              <th>Full</th>
              <th>Open spots</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr
                key={`${row.program}-${row.day}-${row.timeSlot}`}
                className={`owner-dashboard__gap-row owner-dashboard__gap-row--${row.gap}`}
              >
                <td>
                  <span
                    className={`owner-dashboard__gap-badge owner-dashboard__gap-badge--${row.gap}`}
                  >
                    {row.gapLabel}
                  </span>
                </td>
                <td>{row.program}</td>
                <td>
                  <strong>{row.dayLabel}</strong> · {row.timeSlotLabel}
                </td>
                <td>{row.classCount}</td>
                <td>{row.waitlistCount}</td>
                <td>{row.openSpots}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default DemandSupplyGaps;
